module.exports = __webpack_public_path__ + "img/logo_total_energies.43cca901.png";